import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ComparisonTable() {
  const sinKit = [{
    icon: '⏰',
    text: '3-5 horas por semana preparando recursos desde cero'
  }, {
    icon: '😓',
    text: 'Siempre los mismos recursos, las pacientes no progresan'
  }, {
    icon: '💸',
    text: 'Pacientes que abandonan sin saber por qué'
  }, {
    icon: '📋',
    text: 'Sin secuencia clara de intervención'
  }, {
    icon: '😨',
    text: 'Paciente en crisis igual a pánico o improvisación'
  }, {
    icon: '👥',
    text: 'Perfiles muy distintos igual a sesión grupal que no funciona'
  }, {
    icon: '📱',
    text: 'Sin sistema de comunicación entre sesiones'
  }, {
    icon: '💼',
    text: 'Sin identidad profesional visible'
  }];
  const conKit = [{
    icon: '✅',
    text: '10 minutos de preparación. El resto es acompañar.'
  }, {
    icon: '✅',
    text: '80+ herramientas distintas, siempre hay progreso visible'
  }, {
    icon: '✅',
    text: 'Sistema de seguimiento, retención real de pacientes'
  }, {
    icon: '✅',
    text: '6 tomos con secuencia de intervención, avanzan y se quedan'
  }, {
    icon: '✅',
    text: 'Protocolo de DPP y crisis, actuás con seguridad clínica'
  }, {
    icon: '✅',
    text: 'Adaptaciones por perfil, todas progresan en el mismo espacio'
  }, {
    icon: '✅',
    text: 'Guía de comunicación más 30 días de contenido planificado'
  }, {
    icon: '✅',
    text: 'Sistema que justifica cobrar lo que realmente merecés'
  }];
  return <section className="py-12 md:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-18">
      <div className="max-w-5xl mx-auto" data-id="element-19">
        <div className="text-center mb-8 md:mb-16" data-id="element-20">
          <h2 className="text-2xl md:text-5xl font-bold text-navy mb-2 md:mb-4 font-serif italic" data-id="element-21">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-0 rounded-2xl md:rounded-3xl overflow-hidden border border-navy/10 shadow-xl" data-id="element-22">
          {/* SIN KIT */}
          <div className="bg-red-50/50 p-5 md:p-10 border-b md:border-b-0 md:border-r border-navy/10" data-id="element-23">
            <h3 className="text-lg md:text-xl font-bold text-red-900 mb-6 md:mb-8 flex items-center gap-2" data-id="element-24">
              <X className="w-5 h-5 md:w-6 md:h-6 text-red-500" data-id="element-25" />
              SIN KIT PROFESIONAL POSTPARTO:
            </h3>
            <ul className="space-y-4 md:space-y-6" data-id="element-26">
              {sinKit.map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3 text-red-900/80 text-xs md:text-sm font-medium" data-id="element-27">
                  <span className="flex-shrink-0 text-sm md:text-base" data-id="element-28">
                    {item.icon}
                  </span>
                  <span className="leading-relaxed" data-id="element-29">{item.text}</span>
                </li>)}
            </ul>
          </div>

          {/* CON KIT */}
          <div className="bg-sage/10 p-5 md:p-10 relative" data-id="element-30">
            <div className="absolute top-0 left-0 w-full h-1 bg-sage" data-id="element-31"></div>
            <h3 className="text-lg md:text-xl font-bold text-navy mb-6 md:mb-8 flex items-center gap-2" data-id="element-32">
              <Check className="w-5 h-5 md:w-6 md:h-6 text-sage" data-id="element-33" />
              CON KIT PROFESIONAL POSTPARTO:
            </h3>
            <ul className="space-y-4 md:space-y-6" data-id="element-34">
              {conKit.map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3 text-navy/90 text-xs md:text-sm font-bold" data-id="element-35">
                  <span className="flex-shrink-0 text-sm md:text-base" data-id="element-36">
                    {item.icon}
                  </span>
                  <span className="leading-relaxed" data-id="element-37">{item.text}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}